import { GoogleMap } from '@react-google-maps/api';

import { useGoogleMapsApi } from 'hooks/useGoogleMapsApi';
import { useGeocoding } from 'services/shipment/useGeocoding';

import LocationMarker from './LocationMarker';

const mapContainerStyle = {
  width: '100%',
  aspectRatio: '2.6/1',
};

interface Props {
  zipCode: string;
}

const LocationMap = ({ zipCode }: Props) => {
  const { isLoaded, googleMapId } = useGoogleMapsApi();
  const geocodedLocation = useGeocoding(zipCode);

  if (!isLoaded || !geocodedLocation) return null;

  const { latitude, longitude } = geocodedLocation.coordinates;
  const coords = { lat: latitude, lng: longitude };

  return (
    <GoogleMap
      data-testid={'location-map'}
      mapContainerStyle={mapContainerStyle}
      center={coords}
      zoom={10}
      options={{ mapId: googleMapId }}>
      <LocationMarker position={coords} />
    </GoogleMap>
  );
};

export default LocationMap;
